<script>
const nav = [
  {
    route: 'hyperion.product.show',
    icon: 'project',
    text: 'Overview'
  },
  {
    route: 'hyperion.product.biller',
    icon: 'deployment-unit',
    text: 'Biller'
  },
  // {
  //   route: 'hyperion.product.client',
  //   icon: 'solution',
  //   text: 'Client'
  // }, {
  //   route: 'hyperion.product.transaction',
  //   icon: 'barcode',
  //   text: 'Transaction'
  // },
  {
    route: 'hyperion.product.setting',
    icon: 'setting',
    text: 'Setting'
  }
];
export default {
  name: "product-nav",
  props: {
    current: {
      type: String,
      required: true
    },
    product: {
      type: String,
      required: true
    }
  },
  data: () => ({
    nav
  })
}
</script>

<template>
  <a-menu mode="horizontal" :selected-keys="[current]">
    <a-menu-item v-for="item in nav"  :key="item.route">
      <a :href="routeUri(item.route, { product_hash: product })">
        <a-icon :type="item.icon"/>
        {{ item.text }}
      </a>
    </a-menu-item>
  </a-menu>
</template>
